// src/components/ProtectedRoute.tsx
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from "@state/store";

export const ProtectedRoute = () => {
  const token = useSelector((state: RootState) => state.user.token);
  return token ? <Outlet /> : <Navigate to="/ap/login" replace />;
};
